module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "gs-menu"
  }, [_c('el-menu', {
    attrs: {
      "background-color": "#324157",
      "text-color": "#ffffff",
      "active-text-color": "#FFD037",
      "router": true,
      "default-active": _vm.$route.path.split('/')[1] || 'dashboard',
      "mode": "horizontal"
    }
  }, [_c('el-menu-item', {
    staticClass: "gs-logo gs-border-none",
    attrs: {
      "index": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/goship-w.png",
      "alt": "1Express Express"
    }
  })])], 1), _vm._v(" "), _c('el-menu-item', {
    staticClass: "gs-menu-item",
    attrs: {
      "index": "dashboard",
      "active": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_vm._v("Bảng điều khiển")])], 1), _vm._v(" "), _c('el-menu-item', {
    staticClass: "gs-menu-item",
    attrs: {
      "index": "cross-checks"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'cross-check'
      }
    }
  }, [_vm._v("Phiên đối soát")])], 1), _vm._v(" "), _c('el-menu-item', {
    staticClass: "gs-menu-item",
    attrs: {
      "index": "invoices"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'invoice'
      }
    }
  }, [_vm._v("Phiếu\n            chi")])], 1), _vm._v(" "), _c('el-menu-item', {
    staticClass: "gs-menu-item",
    attrs: {
      "index": "compares"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'compare'
      }
    }
  }, [_vm._v("Đơn đối soát")])], 1), _vm._v(" "), _c('el-submenu', {
    staticClass: "gs-menu-item",
    attrs: {
      "index": "5"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Admin")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "users"
    }
  }, [_c('router-link', {
    staticClass: "text-white text-remove-decoration",
    attrs: {
      "to": {
        name: 'user'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user margin-right"
  }), _vm._v("\n              User")])], 1), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "roles"
    }
  }, [_c('router-link', {
    staticClass: "text-white text-remove-decoration",
    attrs: {
      "to": {
        name: 'role'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cog margin-right"
  }), _vm._v("\n              Role")])], 1), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "permissions"
    }
  }, [_c('router-link', {
    staticClass: "text-white text-remove-decoration",
    attrs: {
      "to": {
        name: 'permission'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cogs margin-right"
  }), _vm._v(" Permission")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "header-right gs-border-none pull-right padding-lg-right padding-lg-left"
  }, [_c('el-dropdown', [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('i', {
    staticClass: "el-icon-setting icon-header"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_c('a', {
    staticClass: "text-blue",
    on: {
      "click": function($event) {
        return _vm.logOut()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Logout")])]), _vm._v(" "), _c('el-dropdown-item', [_c('a', {
    staticClass: "text-blue",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changePassword()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-key",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Đổi\n                  mật khẩu")])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "header-right gs-border-none pull-right padding-lg-right padding-lg-left"
  }, [_c('el-popover', {
    ref: "popover",
    attrs: {
      "width": "200",
      "trigger": "hover"
    }
  }, [_c('h3', {
    staticClass: "text-center text-blue remove-margin"
  }, [_vm._v("Thông tin tài khoản")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.accountInfo.name))]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" " + _vm._s(_vm.accountInfo.phone))]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" " + _vm._s(_vm.accountInfo.email))])]), _vm._v(" "), _c('i', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover",
      arg: "popover"
    }],
    staticClass: "fa fa-user-circle-o icon-header"
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Đổi mật khẩu",
      "visible": _vm.changePasswordModal
    },
    on: {
      "update:visible": function($event) {
        _vm.changePasswordModal = $event
      }
    }
  }, [_c('el-form', {
    ref: "changePasswordForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.account,
      "label-width": "120px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', {
    staticClass: "padding-login-item",
    attrs: {
      "label": "Mật khẩu hiện tại",
      "prop": "old_password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Mật khẩu hiện tại"
    },
    model: {
      value: (_vm.account.old_password),
      callback: function($$v) {
        _vm.$set(_vm.account, "old_password", $$v)
      },
      expression: "account.old_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "padding-login-item",
    attrs: {
      "label": "Mật khẩu mới",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Mật khẩu mới"
    },
    model: {
      value: (_vm.account.password),
      callback: function($$v) {
        _vm.$set(_vm.account, "password", $$v)
      },
      expression: "account.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nhập lại mật khẩu",
      "prop": "password_confirmation"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Nhập lại mật khẩu"
    },
    model: {
      value: (_vm.account.password_confirmation),
      callback: function($$v) {
        _vm.$set(_vm.account, "password_confirmation", $$v)
      },
      expression: "account.password_confirmation"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "padding-login-item"
  }, [_c('el-button', {
    staticClass: "width-100",
    attrs: {
      "type": "primary",
      "native-type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Lưu\n              lại")])], 1)], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f3bfd5b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/GsMenu.vue
// module id = 642
// module chunks = 1